export const Panel = ({ label, title, right, children, className = "", testId }) => (
  <section className={`hud-panel p-6 fade-up ${className}`} data-testid={testId}>
    {(label || title || right) && (
      <header className="flex items-start justify-between gap-4 mb-5">
        <div>
          {label && <div className="hud-label">{label}</div>}
          {title && <h2 className="font-display text-base md:text-lg font-semibold tracking-wider text-slate-100 mt-1">{title}</h2>}
        </div>
        {right}
      </header>
    )}
    {children}
  </section>
);

export const PageHeader = ({ code, title, sub, right }) => (
  <div className="flex flex-wrap items-end justify-between gap-6 mb-8 fade-up">
    <div>
      <div className="hud-label">{code}</div>
      <h1 className="font-script text-5xl sm:text-6xl lg:text-7xl text-white mt-2 leading-[1.05]">{title}</h1>
      {sub && <p className="text-slate-400 mt-2 text-base max-w-xl">{sub}</p>}
    </div>
    {right}
  </div>
);

const TONES = {
  high: "text-red-300 border-red-500/40 bg-red-950/30",
  medium: "text-amber-300 border-amber-500/40 bg-amber-950/30",
  low: "text-emerald-300 border-emerald-500/40 bg-emerald-950/30",
  won: "text-emerald-300 border-emerald-500/40 bg-emerald-950/30",
  lost: "text-red-300 border-red-500/40 bg-red-950/30",
  qualified: "text-cyan-200 border-cyan-400/50 bg-cyan-950/40",
};

export const Tag = ({ value, testId }) => (
  <span data-testid={testId} className={`text-[10px] font-semibold uppercase tracking-[0.15em] px-3 py-1 rounded-full border ${TONES[value] || "text-white/80 border-white/20 bg-white/[0.03]"}`}>
    {value}
  </span>
);
